import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Row, Col, Dropdown, Modal, Card } from "react-bootstrap";
import "../styles/navbar.css";
import ContactUsSection from "./ContactUsSection";
import { Link } from 'react-router-dom';

const CustomNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showContactModal, setShowContactModal]=useState(false);
  const [showMenuModal, setShowMenuModal] = useState(false);

  const handleShowMenuModal = () => setShowMenuModal(true);
  const handleCloseMenuModal = () => setShowMenuModal(false);

  const handleShowModal = () => setShowModal(true);
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleCloseContactModal = () => setShowContactModal(false);

  const cardsData = [
    { id: 1, title: "Malibu", image: "/assets/images/search1.jpg" },
    { id: 2, title: "Bel Air", image: "/assets/images/search2.jpg" },
    { id: 3, title: "Pacific Palisades", image: "/assets/images/search3.jpg" },
    { id: 4, title: "Brentwood", image: "/assets/images/search4.jpg" },
    { id: 5, title: "Beverly Glen", image: "/assets/images/search5.jpg" },
    { id: 6, title: "Hollywood", image: "/assets/images/search6.jpg" },
    { id: 7, title: "Santa Monica", image: "/assets/images/search7.jpg" },
    { id: 8, title: "Venice", image: "/assets/images/search8.jpg" },
    { id: 9, title: "Westwood", image: "/assets/images/search9.jpg" },
    { id: 10, title: "Hollywood Hills", image: "/assets/images/search10.jpg" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      className={`web-nav ${scrolled ? "scrolled" : "transparent"}`}
    >
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Row className="d-flex justify-content-between w-100 mb-0 mb-md-0">
            <Col>
              <Nav>
              <Dropdown className="me-sm-2 me-md-3 borderless-dropdown">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  variant=""
                  className="text-decoration-none border-none"
                  aria-label="Properties section dropdown"
                >
                  Properties
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/exclusiveListings">Our Exclusive Listings</Dropdown.Item>
                  <Dropdown.Item as={Link} to="/featuredLeases">Our Featured Leases</Dropdown.Item>
                  <Dropdown.Item as={Link} to="/soldListings">Our Sold Listings</Dropdown.Item>
                  <Dropdown.Item as={Link} to="/globalCollective">Global Collective™</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
                <Nav.Link href="#" aria-label="Home Search section" className="me-sm-2 me-md-3" onClick={handleShowModal}>
                  Home Search
                </Nav.Link>
              </Nav>
            </Col>
            <Col className="d-flex justify-content-center">
              <Navbar.Brand as={Link} to="/">
                <h1 className="fontfamily">Alex Turner</h1>
              </Navbar.Brand>
            </Col>
            <Col className="d-flex justify-content-md-end">
              <Nav>
                <Nav.Link href="#" aria-label="Contact section" className="me-sm-2 me-md-3" onClick={handleShowContactModal}>
                  Contact
                </Nav.Link>
                <Nav.Link href="#" aria-label="Menu section" onClick={handleShowMenuModal}>Menu</Nav.Link>
              </Nav>
            </Col>
          </Row>
        </Navbar.Collapse>

        {/* Home Search Model */}
        <Modal show={showModal} onHide={handleCloseModal} fullscreen variant='dark'>
        <Modal.Header closeButton  className="d-flex justify-content-center align-items-center">
          <h1 className=" display-4 text-center w-100">Click an Area to Start Your Search</h1>
        </Modal.Header>
        <Modal.Body>
        <Row className="g-4 ">
            {cardsData.map((card) => (
              <Col key={card.id} xs={12} sm={6} md={4}>
                <Card className="h-100 w-100 text-center custom-card border-0">
                  <div
                    className="card-background"
                    style={{ backgroundImage: `url(${card.image})`, width:'100%', height:'300px',borderRadius:'10px' }}
                  >
                    <div className="card-overlay">
                      <Card.Title className="text-white " style={{fontFamily:'Cantata One, serif', fontSize:'25px'}}>{card.title}</Card.Title>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>

      {/* Modal for ContactUsSection */}
      <Modal show={showContactModal} onHide={handleCloseContactModal} fullscreen>
        <Modal.Header closeButton>
        <h1 className="ms-5">Contact Us</h1>
        </Modal.Header>
        <Modal.Body>
          <ContactUsSection />
        </Modal.Body>
        
      </Modal>

      {/* Menu Model */}
      <Modal
        show={showMenuModal}
        onHide={handleCloseMenuModal}
        fullscreen
        aria-labelledby="menu-modal"
        className="menu-modal bg-dark"
      >
        <Modal.Header className="bg-dark text-white" closeButton>
          <Modal.Title id="menu-modal" style={{fontFamily:'Cantata One, serif'}} className="text-center w-100">
            Menu
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column align-items-center justify-content-center bg-dark text-white">
          <div className="container">
            <div className="row">
              {/* Left Column */}
              <div className="col-md-6 mb-4">
                <ul className="list-unstyled">
                  
                  <li className="mb-3 ps-5">
                    <Link to="/exclusiveListings" className="text-decoration-none menuText text-white" onClick={handleCloseMenuModal}>
                      Exclusive Listings
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/soldListings" className="text-decoration-none menuText text-white" onClick={handleCloseMenuModal}>
                      Sold Listings
                    </Link>
                  </li>
                  <li className="mb-3 ps-5">
                    <Link to="/globalCollective" className="text-decoration-none menuText text-white " onClick={handleCloseMenuModal}>
                      Global Collective™
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link href="#" className="text-decoration-none menuText text-white " onClick={handleShowModal}>
                      Home Search
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Right Column */}
              <div className="col-md-6 text-right">
                <ul className="list-unstyled">
                <li className="mb-3">
                    <Link to="/" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      Home
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/aboutInfo" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      About Alex
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/exclusiveListings" className="text-decoration-none menuText2 text-white fs-3" onClick={handleCloseMenuModal}>
                      Homes For Sale
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link href="#" className="text-decoration-none menuText2 text-white fs-3" onClick={handleShowContactModal}>
                      Contact
                    </Link>
                  </li>
                  
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
